<template>
    <v-row style="max-width: 600px; margin: 0 auto;" >
        <v-col v-if="validateLoad==true" id="base" md="12" style="height: 100%;" class="my-0 py-0" >
            <v-row justify="center" align="center">
                <v-col calign-self="center" cols="auto">
                    <v-row justify="center" >
                        <v-progress-circular
                        :size="70"
                        :width="7"
                        :color="$store.state.colors.primary"
                        indeterminate
                        ></v-progress-circular>                        
                    </v-row> 
                </v-col>
            </v-row>
        </v-col>        
        <v-col v-else id="base" md="12" style="height: 100%;" class="my-0 py-0" >
            <!-- Back button -->
            <v-row justify="start" align="center" style="height:55px; background-color: #e6e6e6;" class="pt-0">
                <v-col cols="auto">
                    <v-row justify="start">
                        <v-btn @click="$router.push({ name: 'menu'})" icon  :color="$store.state.colors.primary">
                            <v-icon x-large >mdi-chevron-left</v-icon>
                        </v-btn>
                    </v-row>
                </v-col>

                <v-col>
                    <v-row justify="start" class="RestoRegular pl-1">
                        Continuar Pidiendo
                    </v-row>
                </v-col>
            </v-row>

            <v-row class="RestoRegular mt-5 pl-6 mb-4" style="height:40px; font-size: 25px; color: #4D4D4D;">
                Tu pedido
            </v-row>

            <v-row  v-if="solo_sucursal()" class="RestoRegular mt-0 mb-0 pb-0 " style=" font-size: 15px; color: #4D4D4D; width: 95%; margin: 0 auto;">
                ¿Dónde deseas que se te entregue tu pedido?
            </v-row>
            <v-row  v-if="solo_sucursal()" class="RestoBold mt-0 mb-0 pt-0" style="height:40px; color: #4D4D4D; width: 95%; margin: 0 auto;">
                <select @change="changinMethod" v-model="metodo_envio" style="z-index: 2;  widht: 100%; font-size: 16px;" :style="{ 'border': '2.5px solid ' + $store.state.colors.primary }">
                    <option  value="Entrega a domicilio"> En mi domicilio </option>
                    <option  value="Recoger en restaurante"> En sucursal </option>
                </select>
            </v-row>

            <!-- Order Card -->
            <v-row>
                <!-- <v-snackbar v-model="alert" class="font" :top="true" color="warning">
                    Se necesita al menos un platillo
                </v-snackbar>  -->

                <v-col style="width: 100%" class="pt-0">

                    <!-- <v-row justify="start" align="center"  class="pt-0" style="width: 95%; margin: 0 auto;">
                
                        <img  :src="image == null ? require('@/assets/resources/yoomi/yoomy-screen.png'): image" style="width: 100%; height: 35vh; object-fit: cover; object-position: center;">

                    </v-row> -->

                    <v-row class="pl-2 pt-2" justify="start" style="background-color: #F0F0F0; width: 95%; margin: 0 auto; border-bottom: 1px solid #424242 ">
                        <v-col align-self="start" cols="auto">
                            <v-img v-if="metodo_envio == 'Entrega a domicilio'" src="@/assets/resources/user/casa.svg" max-width="25px"></v-img>
                            <v-img v-if="metodo_envio == 'Recoger en restaurante'" src="@/assets/resources/user/restaurante.svg" max-width="25px"></v-img>
                        </v-col>
                        <v-col style="font-size: 12px">
                            <v-row v-if="metodo_envio == 'Entrega a domicilio'" class="RestoBold" style="font-size: 12px; color #424242">
                                {{address.alias}}
                            </v-row>
                            <v-row v-if="metodo_envio == 'Entrega a domicilio'" class="RestoRegular" style="font-size: 12px; color #424242">
                                {{address.calle}} #{{address.num_exterior}} {{address.colonia}}
                            </v-row>
                            <v-row v-if="metodo_envio == 'Recoger en restaurante'" class="RestoBold" style="font-size: 12px; color #424242">
                                {{sucursal.sucursal}}
                            </v-row>
                            <v-row v-if="metodo_envio == 'Recoger en restaurante'" class="RestoRegular" style="font-size: 12px; color #424242">
                                {{sucursal.calle}} {{sucursal.ciudad}}, #{{sucursal.num_exterior}}
                            </v-row>
                            <v-row>
                                {{date}}
                            </v-row>
                            <!-- <v-row>
                                No. de Pedido 9D1E9
                            </v-row> -->
                        </v-col>
                        <v-col cols="auto" align-self="end">
                                <v-btn color="red" rounded @click="validationAlert()" style="color: white;" class="buttonLower" small> Limpiar pedido </v-btn>
                        </v-col>
                    </v-row>

                    <v-row class="mt-0" v-for="(platillo, index) in platillos" :key="index" style="font-size: 12px; border-bottom: 1px solid #424242; background-color: #F0F0F0; width: 95%; margin: 0 auto;">
                        <v-col cols="auto" align-self="center">
                            <v-row justify="center">
                                <v-btn @click="dialogPlat = true; selectedIndex = index;" max-width="30" icon color="red">X</v-btn>
                            </v-row> 
                        </v-col>
                        
                        <v-col align-self="center" class="ml-2">
                            <v-row class="RestoBold" style="font-size: 13px; color: #424242">
                                {{platillo.titulo_platillo}}
                            </v-row>
                            <v-row v-for="(modificador, index) in platillo.modificadores" :key="index">
                                <p v-if="modificador.cantidad != null && modificador.cantidad != 0" class="py-0 my-0"> {{modificador.nombre}} x{{modificador.cantidad}} </p>
                            </v-row>
                            
                            <v-row class="mt-1">
                            </v-row>

                            <v-row v-for="(adicional, index) in platillo.adicionales" :key="index">
                                <p v-if="adicional.cantidad != null && adicional.cantidad != 0" class="py-0 my-0">{{adicional.nombre}} x{{adicional.cantidad}}</p>
                            </v-row>
                        </v-col>
                        <v-col cols="auto" align-self="center" >
                            <v-row justify="start">
                                ${{productPrice(platillo)}}
                            </v-row>
                        </v-col>
                        <v-col cols="auto" align-self="center" >
                            <v-row justify="center" align="center">
                                <v-btn @click="minus(index)"  max-width="30" icon>-</v-btn>
                                 {{platillo.cantidad}}
                                 <v-btn @click="add(index)" max-width="30px" icon>+</v-btn>
                            </v-row>
                        </v-col>
                    </v-row>

                    <v-row class="mt-0 pb-0 mb-0" style="background-color: #F0F0F0; width: 95%; margin: 0 auto; color: #424242">
                        <v-col class="pl-12 pb-0 mb-0" style="font-size: 13px"> 
                            <v-row>
                                <v-col class="py-0 my-0 ml-2" >
                                    <v-row justify="start">
                                        Subtotal:
                                    </v-row>
                                </v-col>
                                <v-col class="py-0 my-0 mr-2">
                                    <v-row justify="end" style="font-size: 17px">
                                        {{subTotal()}}
                                    </v-row>
                                </v-col> 
                            </v-row> 
                            <v-row>
                                <v-col class="py-0 my-0 ml-2">
                                    <v-row justify="start">
                                        Propina:
                                    </v-row>
                                </v-col>
                                <v-col class="py-0 my-0 mr-2">
                                    <v-row justify="end" style="font-size: 17px">
                                        {{calcPropina()}}
                                    </v-row>
                                </v-col> 
                            </v-row> 
                            <v-row style="font-size: 20px;" class="mb-0 pb-0">
                                <v-col class="py-0 my-0 ml-2 ">
                                    <v-row justify="start" >
                                        Total:
                                    </v-row>
                                </v-col>
                                <v-col class="py-0 my-0 mr-2  pb-0 RestoBold" align-self="center">
                                    <v-row justify="end" style="font-size: 17px;" :style="{ 'color': $store.state.colors.primary }">
                                        {{total()}}
                                    </v-row>
                                </v-col> 
                            </v-row> 
                            <v-row style="font-size: 13px;" class="mb-3 pb-0 RestoRegular pl-2">
                                *El monto mínimo de compra es de ${{minimo_compra}}
                            </v-row> 
                        </v-col>
                    </v-row>
                    <v-row v-if="propinasBandera()" class="mt-0 pt-0" style="background-color: #F0F0F0; width: 95%; margin: 0 auto; color: #424242">
                         <v-col class="pl-12 mt-0 pt-0" style="font-size: 15px"> 
                            <v-row class="my-0 py-0 pl-3 RestoRegular">
                                Agregar propina
                            </v-row>
                            <v-row class="my-0 py-0 pl-2" >
                                <v-col cols="auto" class="mr-2 my-0 py-0">
                                    <v-row class="my-0 pb-0"> 
                                        <v-radio-group dense class="mt-0" hide-details v-model="propina">
                                            <v-radio
                                                :color="$store.state.colors.primary"
                                                label="Efectivo"
                                                value="0"
                                            ></v-radio>
                                        </v-radio-group>    
                                    </v-row>
                                </v-col>

                                <v-col cols="auto" class="mr-2 my-0 py-0">
                                    <v-row class="my-0 pb-0"> 
                                        <v-radio-group dense class="mt-0" hide-details v-model="propina">
                                            <v-radio
                                                :color="$store.state.colors.primary"
                                                label="10%"
                                                value="10"
                                            ></v-radio>
                                        </v-radio-group>    
                                    </v-row>
                                </v-col>

                                <v-col cols="auto" class="mr-2 my-0 py-0">
                                    <v-row  class="my-0 py-0"> 
                                        <v-radio-group dense class="mt-0" hide-details v-model="propina">
                                            <v-radio
                                                :color="$store.state.colors.primary"
                                                label="12%"
                                                value="12"
                                            ></v-radio>
                                        </v-radio-group>    
                                    </v-row>
                                </v-col>

                                <v-col cols="auto" class="mr-2 my-0 py-0">
                                    <v-row class="my-0 py-0"> 
                                    <v-radio-group dense class="mt-0 " hide-details v-model="propina">
                                        <v-radio
                                            :color="$store.state.colors.primary"
                                            label="15%"
                                            value="15"
                                        ></v-radio>
                                    </v-radio-group>    
                                    </v-row>
                                </v-col>

                                <v-col cols="auto" class="my-0 py-0">
                                    <v-row  class="my-0 py-0" > 
                                        <v-col cols="auto" class=" my-0 py-0 pr-1 mr-0">
                                            <v-row>
                                            <v-radio-group dense class="mt-0" hide-details v-model="propina">
                                                <v-radio
                                                    :color="$store.state.colors.primary"
                                                    value="Otro"
                                                ></v-radio>
                                            </v-radio-group>    
                                            </v-row>
                                        </v-col>
                                        <v-col align-self="center" style="padding-top: 5px !important">
                                            <v-row style="max-width: 100px">
                                                <currency-input :allow-negative="false" :value-range="{ max: maxPro }" v-model="otro" locale="en-US" currency="USD" style="border: thin solid rgba(0,0,0,.42); border-radius: 4px; width: 100%; background-color: white" />
                                            </v-row>
                                        </v-col>
                                    </v-row>
                                </v-col>

                                <!-- <v-col cols="auto" align-self="start" class="pl-0 ml-0 my-0 pb-0 pt-1">
                                    
                                </v-col> -->

                                
                            </v-row>
                         </v-col>
                    </v-row>
                    <v-row justify="center" style="background-color: #F0F0F0; width: 95%; margin: 0 auto; text-align: center; color: #4D4D4D " class="RestoRegular">
                        <v-col >
                            <v-textarea clearable clear-icon="mdi-close-circle"  label="Comentario opcional" v-model="comentarios" solo dense :color="$store.state.colors.primary" auto-grow rows="1" ></v-textarea>
                        </v-col>
                    </v-row>

                    <v-row justify="end" style="background-color: #F0F0F0; width: 95%; margin: 0 auto;" class="pr-4 pb-4">
                        <v-btn @click="validation();" :color="$store.state.colors.primary" :disabled="validateMin()" dense rounded class="buttonLower ml-2" style="color: white; height: 30px; width: 120px; font-size: 12px">Pagar</v-btn>
                    </v-row>

                </v-col>
            </v-row>

        </v-col>
        <!-- ELIMINAR PEDIDO -->
         <v-dialog v-model="dialog" max-width="290">
            <v-card>
                <v-card-title class="headline"><span>¿Deseas limpiar <br> todo tu pedido?</span></v-card-title>
                <!-- <v-card-text>
                Esto borrara todos los platillos que hayas añadido ¿Deseas continuar?
                </v-card-text> -->

                <v-card-actions>
                <v-spacer></v-spacer>

                <v-btn @click="dialog = false" :color="$store.state.colors.primary" style="color: white" class="buttonLower">
                    No
                </v-btn>

                <v-btn @click="cleanOrder(); dialog = false" :color="$store.state.colors.primary" style="color: white" class="buttonLower">
                    Sí
                </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <!-- ELIMINAR PLATILLO -->
        <v-dialog v-model="dialogPlat" max-width="290">
            <v-card>
                <v-card-title class="headline"><span>¿Deseas eliminar <br> el platillo</span></v-card-title>
                <!-- <v-card-text>
                Esto borrara todos los platillos que hayas añadido ¿Deseas continuar?
                </v-card-text> -->

                <v-card-actions>
                <v-spacer></v-spacer>

                <v-btn @click="dialogPlat = false" :color="$store.state.colors.primary" style="color: white" class="buttonLower">
                    No
                </v-btn>

                <v-btn @click="deletePlatillo(selectedIndex); dialogPlat = false" :color="$store.state.colors.primary" style="color: white" class="buttonLower">
                    Sí
                </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

    </v-row>
</template>


<script>

export default {
    data() {
        return {
            comentarios: "",
            sucursal: JSON.parse(localStorage.getItem("sucursalData")),
            metodo_envio: "Entrega a domicilio",
            alertMV: false,
            minimo_compra: localStorage.getItem("minimo_pedido"),
            maxPro: 0,
            totalWithoutP: 0,
            propina: "0",
            otro: null,
            date:null,
            alert:false,
            dialog: false,
            dialogPlat: false,
            idOrder:null,
            selectedIndex: null,
            addresses: null,
            active: null,
            platillos: this.$store.state.lista_platillos,
            image: null,
            address:JSON.parse(localStorage.getItem("addressUser")),
            validateLoad:true,
        }
    },
    created() {
        if(localStorage.getItem('comentarios'))
            this.comentarios = localStorage.getItem('comentarios');

        if(localStorage.getItem('solo_sucursal') != 'Y')
        {
            if(localStorage.getItem('metodo_envio'))
                this.metodo_envio = localStorage.getItem('metodo_envio')
            else
                this.metodo_envio = "Entrega a domicilio"
        }
        else
            this.metodo_envio = "Recoger en restaurante"
        // if(this.$store.state.lista_platillos = null)

        // console.log("PARAMETROS RUTEO: ", this.$route.params);
        this.idOrder=this.$route.params.id;
        this.$store.state.hideFooter = false;
        // console.log("EL OBJETO PLATILLO: ",this.$store.state.lista_platillos);
        // console.log("LOCAL: ", JSON.parse(localStorage.getItem('platillos')));
        this.validateLoad=false;
        var f = new Date();
        this.date = f.getDate() + "/" + (f.getMonth() +1) + "/" + f.getFullYear();
    },
    watch: {
        otro() {
            this.maxPro = this.totalWithoutP * 0.25;
        }
    },
    methods: {
        solo_sucursal() {
            if(localStorage.getItem('solo_sucursal') == 'Y')
                return false;
            else    
                return true;
        },
        changinMethod() {
            localStorage.setItem('metodo_envio',this.metodo_envio);
        },
        validateMin() {
            if( this.totalWithoutP >= parseInt(localStorage.getItem("minimo_pedido")) )
                 return false;
            else
                return true
        },
        calcPropina() {
            var suma = 0;
            if(this.propina == "Otro")
                suma = this.otro
            else if(this.propina == "0")
                suma = 0;
            else
                suma = (parseInt(this.propina)*this.totalNum()) / 100
            const formatter = new Intl.NumberFormat('en-US', {
                    style: 'currency',
                    currency: 'USD',
                    minimumFractionDigits: 2
            })
            return formatter.format(suma);
        },
        propinasBandera() {
            if(localStorage.getItem('propinasBandera') == 'S')
                return true;
            else   
                return false;
        },
        cleanOrder(){
            this.comentarios = ""
            localStorage.removeItem('comentarios'); 
            localStorage.removeItem('metodo_envio'); 
            this.metodo_envio = "Entrega a domicilio"
            // console.log("ENTRANDO CLEAN");
            this.$store.state.lista_platillos = []; 
            this.platillos = [];
            // var x = []
            localStorage.setItem('platillos', JSON.stringify([]));
            // localStorage.setItem('platillos', JSON.stringify(x));
            // localStorage.removeItem('platillos');
            // // localStorage.removeItem('platillos');
            // this.$store.state.lista_platillos = null;
            // this.$store.dispatch('initilizePedido')
            // platillos = []
        },
        deletePlatillo(index) {
            // console.log(index);
            // console.log(this.platillos)
            this.$store.state.lista_platillos.splice(index,1)
            localStorage.setItem('platillos', JSON.stringify(this.$store.state.lista_platillos));
        },
        total() {
            
                var suma = 0;
                for(let platillo in this.platillos)
                {
                    var adi = 0;
                    var suma_temp = 0;
                    var modi = 0;
                    // console.log("Platillos ",this.platillos[platillo]);
                    // suma += parseFloat(this.platillos[platillo].precio_unitario) * parseInt(this.platillos[platillo].cantidad);
                    if(this.platillos[platillo].adicionales)
                    {
                        for(var i = 0; i < this.platillos[platillo].adicionales.length; i++)
                        if(this.platillos[platillo].adicionales[i].cantidad != null && this.platillos[platillo].adicionales[i].cantidad != 0)
                            adi+= parseFloat(this.platillos[platillo].adicionales[i].precio_unitario)*this.platillos[platillo].adicionales[i].cantidad;
                    }
                    if(this.platillos[platillo].modificadores){
                        modi = 1;
                    }
                    
                    suma_temp = ((parseFloat(this.platillos[platillo].precio_unitario)*modi) + adi) * parseInt(this.platillos[platillo].cantidad);
                    suma+=suma_temp;
                }
                var propina = 0;
                if(this.propina == "Otro")
                    propina = this.otro
                else if(this.propina == "0")
                    propina = 0;
                else
                    propina = (parseInt(this.propina)*this.totalNum()) / 100
                const formatter = new Intl.NumberFormat('en-US', {
                    style: 'currency',
                    currency: 'USD',
                    minimumFractionDigits: 2
                })
                suma += propina;
                localStorage.setItem("amount",suma);
                return formatter.format(suma);
        },
        subTotal() {
                var suma = 0;
                for(let platillo in this.platillos)
                {
                    var adi = 0;
                    var suma_temp = 0;
                    var modi = 0;
                    // console.log("Platillos ",this.platillos[platillo]);
                    // suma += parseFloat(this.platillos[platillo].precio_unitario) * parseInt(this.platillos[platillo].cantidad);
                    if(this.platillos[platillo].adicionales)
                    {
                        for(var i = 0; i < this.platillos[platillo].adicionales.length; i++)
                        if(this.platillos[platillo].adicionales[i].cantidad != null && this.platillos[platillo].adicionales[i].cantidad != 0)
                            adi+= parseFloat(this.platillos[platillo].adicionales[i].precio_unitario)*this.platillos[platillo].adicionales[i].cantidad;
                    }
                    if(this.platillos[platillo].modificadores){
                        modi = 1;
                    }
                    suma_temp = ((parseFloat(this.platillos[platillo].precio_unitario)*modi) + adi) * parseInt(this.platillos[platillo].cantidad);
                    suma+=suma_temp;
                }
                this.totalWithoutP = suma;
                
                this.maxPro = this.totalWithoutP * 0.25;
                const formatter = new Intl.NumberFormat('en-US', {
                    style: 'currency',
                    currency: 'USD',
                    minimumFractionDigits: 2
                })
                localStorage.setItem("amount",suma);
                return formatter.format(suma);
        },
        totalNum() {
            var suma = 0;
                for(let platillo in this.platillos)
                {
                    var adi = 0;
                    var suma_temp = 0;
                    var modi = 0;
                    // console.log("Platillos ",this.platillos[platillo]);
                    // suma += parseFloat(this.platillos[platillo].precio_unitario) * parseInt(this.platillos[platillo].cantidad);
                    if(this.platillos[platillo].adicionales)
                    {
                        for(var i = 0; i < this.platillos[platillo].adicionales.length; i++)
                        if(this.platillos[platillo].adicionales[i].cantidad != null && this.platillos[platillo].adicionales[i].cantidad != 0)
                            adi+= parseFloat(this.platillos[platillo].adicionales[i].precio_unitario)*this.platillos[platillo].adicionales[i].cantidad;
                    }
                    if(this.platillos[platillo].modificadores){
                        modi = 1;
                    }
                    suma_temp = ((parseFloat(this.platillos[platillo].precio_unitario)*modi) + adi) * parseInt(this.platillos[platillo].cantidad);
                    suma+=suma_temp;
                }
                return suma;
        },
        productPrice(product)
        {
            var adi = 0;
            var modi = 0;
            var total = 0;
            if(product.adicionales)
            {
                for(var i = 0; i < product.adicionales.length; i++)
                if(product.adicionales[i].cantidad != null && product.adicionales[i].cantidad != 0)
                    adi+= parseFloat(product.adicionales[i].precio_unitario)*product.adicionales[i].cantidad;
            }
            if(product.modificadores){
                modi = 1;
                // console.log("M",modi);
            }

            total = ((product.precio_unitario*modi) + adi) * product.cantidad;
            return total;
        },
        add(index){
            this.platillos[index].cantidad++;
            localStorage.setItem('platillos', JSON.stringify(this.platillos));
        },
        minus(index){
            if(this.platillos[index].cantidad > 1)
            {   
                this.platillos[index].cantidad--;
                localStorage.setItem('platillos', JSON.stringify(this.platillos));
            }
                
        },
        validation()
        {
            if(this.otro == null)
                this.otro = 0;
            if(this.platillos.length!=0)
            {
                if(this.propina == null)
                    this.propina = "0"
                localStorage.setItem('metodo_envio',this.metodo_envio);
                localStorage.setItem('platillos', JSON.stringify(this.platillos));
                // console.log("PARSEADO: ", JSON.parse(localStorage.getItem('platillos')))
                if(this.propina == "Otro")
                    localStorage.setItem("propina", this.otro)
                else if(this.propina == "0")
                    localStorage.setItem("propina", 0)
                else
                    localStorage.setItem("propina", (parseInt(this.propina)*this.totalNum()) / 100)
                // console.log(localStorage.getItem("propina"));
                localStorage.setItem("comentarios", this.comentarios);
                this.$router.push({ name: 'final_order'});
                this.$nextTick(() => {
                    location.reload();
                });
            }
            else{
                this.$store.state.alertState = true;
                this.$store.state.alertMessage = "Se necesita al menos un platillo";
                this.$store.state.alertColor = "warning";
                setTimeout(() => {
                this.$store.state.alertState = false;
                }, 4000);               
            }
        },
        validationAlert()
        {
            if(this.platillos.length==0)
            {
                this.$store.state.alertState = true;
                this.$store.state.alertMessage = "Se necesita al menos un platillo";
                this.$store.state.alertColor = "warning";
                setTimeout(() => {
                this.$store.state.alertState = false;
                }, 4000);                
            }
            else{
                this.dialog=true;
            }
        }
    }
}
</script>

<style scoped>

    select {
        display: block;
        background: transparent;
        line-height: 1;
        font-size: 18px;
        height: 30px;
        padding: 1px 1px 1px 2px;
        width: 100%;
        border-radius: 4px;
        -webkit-appearance: menulist;
    }

    select:focus{ outline: none;}
    select::-ms-expand { display: block; }

    .rounded-btn{
       border-radius:20px;
    }

    .hidscroll {
        overflow-y: scroll;
        overflow-x: hidden;
    }

    .active {
        color: white;
    }
    .font
    {
        font-size: 16px;
    }

</style>